import React, { lazy, Suspense, useMemo } from "react";
import { useSelector } from "react-redux";
import { CommonModal, modalRegistry } from "../Modal";
import { uiActions } from "../store/ui/ui-slice";
import { dispatch } from "../store";

const Modal = () => {
  const { modalOptions } = useSelector((state) => state.ui);

  const handleModalHide = () => {
    dispatch(uiActions.clearModalOption());
  };

  const LazyComponent = useMemo(() => {
    if (!modalOptions?.isOpen || !modalOptions?.name) return null;
    const importer = modalRegistry[modalOptions.name];
    return importer ? lazy(importer) : null;
  }, [modalOptions?.name, modalOptions?.isOpen]);

  return (
    <CommonModal
      isShow={modalOptions?.isOpen}
      handleShowHide={handleModalHide}
      modalTitle={modalOptions?.modalTitle}
    >
      {LazyComponent && (
        <Suspense fallback={<p>Loading...</p>}>
          <LazyComponent
            dispatch={dispatch}
            uiActions={uiActions}
            handleShowHide={handleModalHide}
            rowData={modalOptions?.rowData}
            payloadData={modalOptions?.payloadData}
            refetch={modalOptions?.refetch}
          />
        </Suspense>
      )}
    </CommonModal>
  );
};

export default Modal;
